import {
  GET_CLIENT_FAILURE,
  GET_CLIENT_REQUEST,
  GET_CLIENT_SUCCESS,
} from "../../actions/actionTypes";

const initialState = {
  loading: false,
  client: {},
  error: "",
  scoring: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENT_REQUEST:
      return {
        ...state,
        client: {},
        loading: true,
      };
    case GET_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        client: action.payload,
        error: "",
      };
    case GET_CLIENT_FAILURE:
      return {
        ...state,
        loading: false,
        client: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
